module.exports = __webpack_public_path__ + "static/img/company3.cd3b706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company3.png
// module id = SqnY
// module chunks = 1